module.exports = __webpack_public_path__ + "static/img/Homev33.768c767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/Homev33.png
// module id = m+BM
// module chunks = 0